import React, { useEffect, useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Web3 from 'web3';
import { toast } from 'react-toastify';
import { Button, FormControl, FormHelperText, InputLabel, Typography, Box, RadioGroup, Radio, FormControlLabel, InputAdornment } from '@mui/material';
import Api from '../../utils/Api';
import components from '../../components';
import ApiCall from '../../utils/Api';
import axios from 'axios';
import contractABI from '../../utils/contractABI';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
const TokenizeData = () => {
  const Navigate = useNavigate()
  const contractAddress = import.meta.env.VITE_APP_contractAddress; // Replace with your contract address
  const TDUcontractAddress = import.meta.env.VITE_APP_TDUcontractAddress
  const [unitType, setUnitType] = React.useState('');
  // Add state for user type (TDU-Fund User or Data Provider)
  const [userType, setUserType] = useState('dataProvider'); // Default to dataProvider, should be set based on actual user type
  // Detect Fund Provider to control field visibility
  const role = typeof window !== 'undefined' ? localStorage.getItem('role') : null;
  const isFundProvider = role === 'Fund Provider';

  const handleUnitTypeChange = (event) => {
    setUnitType(event.target.value);
  };
  const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };


  const ClearAll = () => {
    setdataunittype("")
    setdata("")
    setinstrument("")
    setPrice(0)
    setTDUPrice(0)
  }

  const [contract, setContract] = useState(null);
  const [isconnected, setisconnected] = useState(false);
  const [web3, setWeb3] = useState(null);
  const [TDUPrice, setTDUPrice] = useState(0)
  const [WalletAddresses, setWalletAddresses] = useState();
  // Pricing model
  const [pricingType, setPricingType] = useState('levels'); // default to levels per design
  const [hasMultipleLevels, setHasMultipleLevels] = useState(true);
  const [pricingLevels, setPricingLevels] = useState([
    { levelName: '1', maxAmountUSD: 0, annualYieldPercent: 0, ticketUSD: 0, ticketETH: 0, coinPriceUSD: 0 }
  ]);
  // Coin and Yield details
  const [selectedCoin, setSelectedCoin] = useState('TDUX');
  // Removed global coinPriceUSD - now stored per level
  useEffect(() => {
    const getWalletAddress = async () => {
      try {
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });

        const data = await ApiCall.SECURE_API.get(
          "/user/GetWalletAddresses"
        );
        let WalletsIds = data.data.data || [];
        let options = [];
        let connectedWallet = "";

        // Show all MetaMask accounts, but prioritize registered ones
        for (let index = 0; index < accounts.length; index++) {
          const account = accounts[index];
          const isRegistered = WalletsIds.some(registeredWallet => 
            registeredWallet.toLowerCase() === account.toLowerCase()
          );
          
          if (isRegistered) {
            // Add registered wallets first
            options.unshift(account);
          } else {
            // Add non-registered wallets after
            options.push(account);
          }
        }
        
        // If no MetaMask accounts but we have registered wallets, show them
        if (options.length === 0 && WalletsIds.length > 0) {
          options = WalletsIds;
        }
        
        console.log("Available wallet addresses:", options);
        setWalletAddresses(options);

        // Set default account if available
        if (options.length > 0 && !accountNumber) {
          setaccountNumber(options[0]);
        }

        // const formattedOptions = data.data.data.reduce((options, [value, label]) => {
        //   options[value] = label;
        //   return options;
        // }, {});
      } catch (error) {
        console.log("Error getting wallet addresses:", error);
        // Fallback: show any registered wallets even if MetaMask isn't connected
        try {
          const data = await ApiCall.SECURE_API.get("/user/GetWalletAddresses");
          const WalletsIds = data.data.data || [];
          setWalletAddresses(WalletsIds);
          if (WalletsIds.length > 0 && !accountNumber) {
            setaccountNumber(WalletsIds[0]);
          }
        } catch (fallbackError) {
          console.log("Fallback wallet fetch failed:", fallbackError);
        }
      }
    };
    getWalletAddress();
  }, []);

  const initWeb3 = async () => {
    if (window.ethereum) {
      // Modern dapp browsers
      const web3Instance = new Web3(window.ethereum);
      try {
        // Request user approval to access their accounts
        await window.ethereum.enable();
        setWeb3(web3Instance);
        setisconnected(true);
        localStorage.setItem("web3Instance", JSON.stringify(web3Instance)); // Save web3 instance to local storage

      } catch (error) {
        console.error(error);
      }
    } else if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    } else {
      // Non-dapp browsers
      console.log("Please install MetaMask!");
    }
  };
  useEffect(() => {
    initWeb3()
  }, [])
  useEffect(() => {
    const getWalletAddress = async () => {
      try {
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });

        const data = await ApiCall.SECURE_API.get(
          "/user/GetWalletAddresses"
        );
        let WalletsIds = data.data.data || [];
        let options = [];
        let connectedWallet = "";

        // Show all MetaMask accounts, but prioritize registered ones
        for (let index = 0; index < accounts.length; index++) {
          const account = accounts[index];
          const isRegistered = WalletsIds.some(registeredWallet => 
            registeredWallet.toLowerCase() === account.toLowerCase()
          );
          
          if (isRegistered) {
            // Add registered wallets first
            options.unshift(account);
          } else {
            // Add non-registered wallets after
            options.push(account);
          }
        }
        
        // If no MetaMask accounts but we have registered wallets, show them
        if (options.length === 0 && WalletsIds.length > 0) {
          options = WalletsIds;
        }
        
        console.log("Available wallet addresses:", options);
        setWalletAddresses(options);

        // Set default account if available
        if (options.length > 0 && !accountNumber) {
          setaccountNumber(options[0]);
        }

        // const formattedOptions = data.data.data.reduce((options, [value, label]) => {
        //   options[value] = label;
        //   return options;
        // }, {});

        // If we have wallet addresses, set isconnected to true
        if (options.length > 0) {
          setisconnected(true);
        }
      } catch (error) {
        console.log("Error getting wallet addresses:", error);
        setisconnected(false);
      }
    };
    
    // Only get wallet addresses if MetaMask is connected
    if (isconnected) {
      getWalletAddress();
    }
  }, [isconnected]);
  function isValidFormat(str) {
    // Regular expression to match the format LEXS-FX-TDU-6m-FWD-YYYY-MM-DD
    const regex = /^LEXS-FX-TDU-6m-FWD-\d{4}-\d{2}-\d{2}$/;

    // Test the string against the regular expression
    return regex.test(str);
  }
  useEffect(() => {
    const initContract = async () => {
      try {
        const deployedContract = new web3.eth.Contract(
          contractABI,
          contractAddress
        );
        setContract(deployedContract);

        // localStorage.setItem(
        //   "deployedContract",
        //   JSON.stringify(deployedContract)
        // ); // Save web3 instance to local storage

      } catch (error) {
        console.log(error);
      }
    };

    if (web3) {
      initContract();
    }
  }, [web3]);
  // const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [data, setdata] = useState("");
  const [dataunittype, setdataunittype] = useState("None");
  const [instrument, setinstrument] = useState("");
  const [accountNumber, setaccountNumber] = useState("");
  const [Validation, setValidation] = useState({
    market: "",
    instrument: "",
    UnitName: "",
    priceUSD: "",
    priceTDU: "",
    metaAccountNumber: "",
    pricingLevels: "",
  })

  // Auto-populate Instrument for Fund Provider and lock the field
  useEffect(() => {
    if (isFundProvider) {
      setinstrument("Fund");
    }
  }, [isFundProvider]);

  const validateForm = () => {
    console.log("=== VALIDATION DEBUG ===");
    console.log("pricingType in validation:", pricingType);
    console.log("pricingLevels in validation:", pricingLevels);
    console.log("price in validation:", price);
    console.log("TDUPrice in validation:", TDUPrice);
    
    let isValid = true;
    const errors = {};

    // Validate market only for non-Fund Providers
    if (!isFundProvider) {
      if (!dataunittype || dataunittype === "None") {
        isValid = false;
        errors.market = "Market is required";
      }
    }

    // Validate instrument field
    if (!instrument.trim()) {
      isValid = false;
      errors.instrument = "Instrument is required";
    }
    if (!accountNumber.trim()) {
      isValid = false;
      errors.metaAccountNumber = "Meta Account Number is required";
    }

    // Validate UnitName field
    if (!data.trim()) {
      isValid = false;
      errors.UnitName = "Unit Name is required";
    }
    // else if (!isValidFormat(data.trim())){
    //   isValid = false;
    //   errors.UnitName = "Invalid format. Please use the format LEXS-FX-TDU-6m-FWD-YYYY-MM-DD. For example: LEXS-FX-TDU-6m-FWD-2024-04-11.d";
    // }

    if (pricingType === 'fixed') {
      console.log("Validating fixed pricing");
      // Validate priceUSD field
      if (price <= 0) {
        isValid = false;
        errors.priceUSD = "Price in USD must be greater than 0";
      }
      // Validate priceTDU field
      if (TDUPrice <= 0) {
        isValid = false;
        errors.priceTDU = "Price in TDU must be greater than 0";
      }
    } else {
      console.log("Validating levels pricing");
      // Validate pricing levels
      if (!pricingLevels.length) {
        isValid = false;
        errors.pricingLevels = "Add at least one pricing level";
      } else {
        const invalid = pricingLevels.some(l => !l || !l.levelName || Number(l.maxAmountUSD) <= 0 || Number(l.annualYieldPercent) < 0 || Number(l.ticketUSD) <= 0 || Number(l.ticketETH) <= 0);
        if (invalid) {
          isValid = false;
          errors.pricingLevels = "Fill Level Name, Max USD, Yield, Ticket USD/ETH";
        }
      }
    }

    return { isValid, errors };
  };
  const [BackDropState, setBackDropState] = useState(false)
  const getAllDataUnits = async (accountNumber) => {
    try {
      const accounts = await web3.eth.getAccounts();
      const providerAddress = accounts[0];
      console.log(providerAddress);
      // setprov_Address(providerAddress);
      if (contract && contract.methods) {
        // Use main contract for getting data units
        const mainContract = new web3.eth.Contract(contractABI, contractAddress);
        const result = await mainContract.methods.getAllDataUnits().call();
        const data = result.filter((item) => (item.provider.toUpperCase() === accountNumber.toUpperCase())).pop()

        // console.log(filteredArray);
        // setResults(result);
        console.log(result);
        return data.id
      } else {
        console.log("Contract object is null or undefined.");
      }
    } catch (error) {
      console.log("Error getting all data units:", error);
    }
  };
  const handleSave = () => {
    console.log("Price:", price);
    createDataUnit();

    // Swal.fire({
    //   title: "Select Wallet Address",
    //   input: "select",
    //   inputOptions: WalletAddresses,
    //   inputPlaceholder: "Select Wallet Address",
    //   showCancelButton: true,
    //   inputValidator: (value, index) => {


    //     // return new Promise((resolve) => {
    //     //   if (value === "oranges") {
    //     //     resolve();
    //     //   } else {
    //     //     resolve("You need to select oranges :)");
    //     //   }
    //     // });
    //   },
    // });

    // getAllDataUnits()
    handleClose();
  };const [price, setPrice] = useState(0);
  const handleClose = () => {
    setOpen(false);
  };
  const [showPopup, setShowPopup] = useState(false);
  const [resultq, setResultq] = useState("");
  const [address, setAddress] = useState("");

  const [buyerDataUnits, setBuyerDataUnits] = useState([]);
  // const createDataUnitApi = () => {
  //   var myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");
  //   myHeaders.append("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NTc4MDg4YmM0Y2ViODAwMjBlOGQ0Y2UiLCJlbWFpbCI6InByb3ZpZGVyT25lQGdtYWlsLm9jbSIsInJvbGUiOiJwcm92aWRlciIsImlhdCI6MTcwMjM2NTM4NiwiZXhwIjoxNzAyMzcyNTg2fQ.b92x6Iel3A79rahUcjhVGFsAVxRoRxUXwO8pgSEyUpk");

  //   var raw = JSON.stringify({
  //     "market": "xxyyzz",
  //     "instrument": "qqqwwwweeee",
  //     "name": "vvvbbbbnnn",
  //     "price": {
  //       "usd": 4455
  //     }
  //   });

  //   var requestOptions = {
  //     method: 'POST',
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: 'follow'
  //   };

  //   fetch("http://44.194.122.106/api/dataunit/createDataUnit", requestOptions)
  //     .then(response => response.json())
  //     .then(result => console.log(result))
  //     .catch(error => console.log('error', error));
  // }
  const getethtoUSD=async()=>{
    console.log("getethtoUSD")
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://pro-api.coinmarketcap.com/v1/cryptocurrency/quotes/latest?convert=USD&id=1027',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'X-CMC_PRO_API_KEY': '0e9bd15d-b37e-4f73-8c17-e6dffdae4371'

      }
    };

    axios.request(config)
    .then(async(response) => {
      // const data = await response.json();
      // const ethPrice = data.data.ETH.quote.USD.price;
    })
    .catch((error) => {
      console.log(error);
    });
  }

  useEffect(()=>{
    // if(TDUPrice===0){
    //   setPrice(0)
    // }
    // if(!price){
    //   setTDUPrice(0)
    // }
    if(!TDUPrice){
            setPrice(0)

    }
    console.log(TDUPrice, price)
  },[
    TDUPrice,price
  ])
useEffect(()=>{
  getethtoUSD()
},[])
const [ethPrice, setEthPrice] = useState(null);

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await ApiCall.Api.get('/thirdPartyApi/getCryptoData');
      const ethereumData = response.data.data['1027'];
      // Extract the USD price from the API response
      const usdPrice = ethereumData.quote.USD.price;
      // Update the state with the USD price


      setEthPrice(usdPrice);
      // const exchangeRate = ethereumData.quote.USD.price;
      // const convertedUsdAmount = parseFloat(inputEthValue) * exchangeRate;
      // setUsdAmount(convertedUsdAmount.toFixed(2));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  fetchData();
}, []);

// Calculate ETH value when USD price or ETH price changes
useEffect(() => {
  if (TDUPrice && ethPrice) {
    const ethValue = usdToEth(TDUPrice);
    setPrice(ethValue);
    console.log('Initial calculation: USD =', TDUPrice, 'ETH =', ethValue);
  }
}, [TDUPrice, ethPrice]);

// Removed old getPriceInUsd and getPriceInETH functions - now using usdToEth and ethToUsd
  const usdToEth = (usd) => {
    if (!ethPrice) {
      console.log('ETH price not available yet');
      return 0;
    }
    const eth = Number(usd) / ethPrice;
    console.log(`Converting ${usd} USD to ETH: ${usd} / ${ethPrice} = ${eth}`);
    return Number.isFinite(eth) ? Number(eth.toFixed(6)) : 0;
  };
  const ethToUsd = (eth) => {
    if (!ethPrice) return 0;
    const usd = Number(eth) * ethPrice;
    return Number.isFinite(usd) ? Number(usd.toFixed(6)) : 0;
  };
  // ---------- Pricing Levels helpers ----------
  const addPricingLevel = () => {
    console.log("Adding new pricing level");
    setPricingLevels(prev => {
      const newLevels = [...prev, { levelName: String(prev.length + 1), maxAmountUSD: 0, annualYieldPercent: 0, ticketUSD: 0, ticketETH: 0, coinPriceUSD: 0 }];
      console.log("New pricing levels after add:", newLevels);
      return newLevels;
    });
  };
  const removePricingLevel = (idx) => {
    setPricingLevels(prev => prev.filter((_, i) => i !== idx));
  };
  const updatePricingLevel = (idx, field, val) => {
    console.log(`Updating pricing level ${idx}, field: ${field}, value: ${val}`);
    setPricingLevels(prev => {
      const next = [...prev];
      const level = { ...next[idx] };
      if (field === 'ticketUSD') {
        // Remove leading zeros and parse
        const cleanVal = String(val).replace(/^0+(?=\d)/, '');
        const usd = Math.max(0, Number(cleanVal) || 0); // Prevent negative values
        level.ticketUSD = usd; // Store exact USD value
        level.ticketETH = Number(usdToEth(usd).toFixed(6)); // Calculate ETH equivalent with 6 decimal places
      } else if (field === 'ticketETH') {
        // ETH field should not be editable - it's calculated from USD
        // Keep the current ETH value
        return next;
      } else if (field === 'maxAmountUSD' || field === 'annualYieldPercent' || field === 'coinPriceUSD') {
        // Remove leading zeros and parse
        const cleanVal = String(val).replace(/^0+(?=\d)/, '');
        level[field] = Math.max(0, Number(cleanVal) || 0); // Prevent negative values
      } else if (field === 'levelName') {
        level.levelName = val;
      }
      next[idx] = level;
      console.log(`Updated pricing levels:`, next);
      return next;
    });
  };
  const formatShortUSD = (num) => {
    const n = Number(num);
    if (!Number.isFinite(n)) return '';
    if (n >= 1000000) return `${(n/1000000).toFixed(1).replace(/\.0$/, '')}M`;
    if (n >= 1000) return `${(n/1000).toFixed(0)}k`;
    return `${n}`;
  };
  // Format number to remove leading zeros
  const formatNumber = (num) => {
    const n = Number(num);
    if (!Number.isFinite(n) || n === 0) return '';
    return String(n).replace(/^0+/, '').replace(/^0*\./, '0.');
  };
  // Calculate investment per ticket (Ticket USD / Coin Price)
  // e.g., $100 ticket / $0.12 coin price = 833.33 TDUX
  // Always returns string with 2 decimals
  const calculateInvestmentPerTicket = (coinPrice, minTicketUSD) => {
    if (!coinPrice || !minTicketUSD || coinPrice === 0) return '0.00';
    const result = Number(minTicketUSD) / Number(coinPrice);
    return Number.isFinite(result) ? result.toFixed(2) : '0.00';
  };
  // Calculate annual yield in coin
  const calculateAnnualYieldInCoin = (investment, yieldPercent) => {
    if (!investment || !yieldPercent) return 0;
    const yieldAmount = (Number(investment) * Number(yieldPercent)) / 100;
    return yieldAmount.toFixed(0);
  };
  const createDataUnit = async () => {
    try {
      console.log("=== CREATE DATA UNIT DEBUG ===");
      console.log("Before validation - pricingType:", pricingType);
      console.log("Before validation - pricingLevels:", pricingLevels);
      console.log("Before validation - pricingLevels.length:", pricingLevels.length);
      console.log("Current price state:", price);
      console.log("Current TDUPrice state:", TDUPrice);
      
      const { isValid, errors } = validateForm()
      console.log("Validation result - isValid:", isValid);
      console.log("Validation result - errors:", errors);
      
      if (isValid == false) {
        console.log("Validation failed:", errors);
        setValidation(errors)
        return
      }
      setValidation({})
      
      console.log("After validation - pricingType:", pricingType);
      console.log("After validation - pricingLevels:", pricingLevels);
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const userAddress = accounts[0];
      
      // Get the data unit creation cost from the contract
      const mainContract = new web3.eth.Contract(contractABI, contractAddress);
      const creationCost = await mainContract.methods.getDataUnitCreationCost().call();
      
      
      setBackDropState(true)
      
      let results = [];
      let unitIds = [];
      
      console.log('Current pricingType:', pricingType);
      console.log('Current pricingLevels:', pricingLevels);
      console.log('pricingLevels.length:', pricingLevels.length);
      console.log('pricingType === "levels":', pricingType === 'levels');
      console.log('typeof pricingType:', typeof pricingType);
      
      if (pricingType === 'levels') {
        // Create single blockchain data unit with all pricing levels as metadata
        console.log('Creating single blockchain data unit with multiple pricing levels:', pricingLevels.length);
        
        // Use the first level's price for the blockchain data unit (minimum ticket size)
        const firstLevel = pricingLevels[0];
        const effectiveEthPrice = String(firstLevel?.ticketETH || 0);
        const weiAmount = web3.utils.toWei(effectiveEthPrice, "ether");
        
        // Validate first level data
        if (!firstLevel.levelName || firstLevel.ticketUSD <= 0) {
          toast.error("First pricing level must have valid data");
          setBackDropState(false);
          return;
        }
        
        // Validate annual yield percentage for first level
        if (firstLevel.annualYieldPercent > 100) {
          toast.error("First level annual yield cannot exceed 100%");
          setBackDropState(false);
          return;
        }
        
        // Check for minimum price
        const minPriceWei = web3.utils.toWei("0.001", "ether"); // 0.001 ETH minimum
        if (BigInt(weiAmount) < BigInt(minPriceWei)) {
          toast.error("Minimum ticket price must be at least 0.001 ETH");
          setBackDropState(false);
          return;
        }
        
        // Create single data unit with all levels information
        const timestamp = Date.now();
        const dataUnitName = `${data}-MultiLevel-${timestamp}`;
        
        console.log(`Creating single blockchain unit with all levels: ${dataUnitName}, Base Price: ${effectiveEthPrice} ETH`);
        console.log(`All levels data:`, pricingLevels);
        
        try {
          const gasEstimate = await mainContract.methods
            .createDataUnit(dataUnitName, weiAmount, dataunittype)
            .estimateGas({ 
              from: accountNumber,
              value: creationCost
            });
          
          console.log(`Single unit gas estimate: ${gasEstimate}`);
          
          const result = await mainContract.methods
            .createDataUnit(dataUnitName, weiAmount, dataunittype)
            .send({ 
              from: accountNumber,
              value: creationCost,
              gas: gasEstimate
            });
          
          results.push(result);
          
          // Get the unit ID
          const unitId = await getAllDataUnits(accountNumber);
          unitIds.push(unitId);
          
          console.log(`Single blockchain data unit created successfully. Transaction hash: ${result.transactionHash}, Unit ID: ${unitId}`);
          
        } catch (blockchainError) {
          console.error('Failed to create blockchain data unit:', blockchainError);
          toast.error(`Failed to create data unit: ${blockchainError.message || 'Unknown error'}`);
          setBackDropState(false);
          return;
        }
        
        console.log(`Single blockchain data unit created with ${pricingLevels.length} pricing levels`);
      } else {
        // Single price mode
        console.log('Going into single price mode - pricingType is not "levels"');
        const effectiveEthPrice = String(price);
        const weiAmount = web3.utils.toWei(effectiveEthPrice, "ether");
        
        console.log('Creating single blockchain data unit with price:', effectiveEthPrice, 'ETH');
        
        try {
          const gasEstimate = await mainContract.methods
        .createDataUnit(data, weiAmount, dataunittype)
            .estimateGas({ 
              from: accountNumber,
              value: creationCost
            });
          
          console.log(`Single unit gas estimate: ${gasEstimate}`);
          
          const result = await mainContract.methods
            .createDataUnit(data, weiAmount, dataunittype)
            .send({ 
              from: accountNumber,
              value: creationCost,
              gas: gasEstimate
            });
          
          results.push(result);
          
          const unitId = await getAllDataUnits(accountNumber);
          unitIds.push(unitId);
          
          console.log('Single blockchain data unit created successfully. Transaction hash:', result.transactionHash, 'Unit ID:', unitId);
        } catch (blockchainError) {
          console.error('Failed to create blockchain data unit:', blockchainError);
          toast.error(`Failed to create data unit: ${blockchainError.message || 'Unknown error'}`);
        }
      }
      
        setBackDropState(false)
      
      if (results.length > 0 && results[0]?.transactionHash) {
        // Handle success for single blockchain data unit
        const transactionHash = results[0].transactionHash;
        const successMessage = pricingType === 'levels' 
          ? `Your data unit with ${pricingLevels.length} pricing levels created successfully!`
          : `Your data unit created successfully!`;
          
        setResultq(
          `${successMessage} Transaction Hash: ${transactionHash}`
        );

        // Create backend entry for the single data unit with all pricing levels
        try {
          if (pricingType === 'levels') {
            // Create single backend entry with all pricing levels
            console.log(`Creating backend entry with ${pricingLevels.length} pricing levels`);
            
            const weiAmount = web3.utils.toWei(String(pricingLevels[0]?.ticketETH || 0), "ether");
            
            const apiPayload = {
          "market": dataunittype,
          "instrument": instrument,
              "name": `${data} - Multi-Level Fund`,
          "fundUnitName": data,
          "pricingType": pricingType,
              "pricingLevels": pricingLevels, // Send all levels as metadata
              "price": weiAmount, // Base price from first level
              "dataunitId": Number(unitIds[0]),
              "transactionHash": transactionHash,
              "providerWalletAddress": accountNumber
            };
            
            console.log("=== API PAYLOAD DEBUG ===");
            console.log("pricingType being sent:", pricingType);
            console.log("pricingLevels being sent:", pricingLevels);
            console.log("Full API payload:", apiPayload);
            
            await ApiCall.SECURE_API.post("/dataunit/createDataUnit", apiPayload);
            
            console.log(`Backend entry created with all pricing levels: Data unit created successfully`);
          } else {
            // Single price mode
            console.log('=== GOING TO SINGLE PRICE MODE ===');
            console.log('pricingType in else branch:', pricingType);
            console.log('pricingLevels in else branch:', pricingLevels);
            const weiAmount = web3.utils.toWei(String(price), "ether");
            const singlePricePayload = {
              "market": dataunittype,
              "instrument": instrument,
              "name": data,
              "fundUnitName": data,
              "pricingType": pricingType,
              "pricingLevels": [],
              "price": weiAmount,
              "dataunitId": Number(unitIds[0]),
              "transactionHash": transactionHash,
              "providerWalletAddress": accountNumber
            };
            
            console.log("=== SINGLE PRICE API PAYLOAD DEBUG ===");
            console.log("pricingType being sent:", pricingType);
            console.log("Full single price API payload:", singlePricePayload);
            
            await ApiCall.SECURE_API.post("/dataunit/createDataUnit", singlePricePayload);
            
            console.log('Backend entry created for single data unit: Data unit created successfully');
          }
          
          toast.success(successMessage);
          ClearAll();

      Swal.fire({
        title: "Success!",
            text: successMessage,
        icon: "success",
      }).then((result2) => {
        if(result2.isConfirmed){
          Navigate("/admin-panel/YourdataUnit")
        }
      });

        setShowPopup(true);
        handleClose();
          console.log("Data unit created:", results);
        } catch (backendError) {
          console.error("Backend API error:", backendError);
          toast.error("Data unit created on blockchain but failed to save to backend. Please contact support.");
        }
      }
    } catch (error) {
      setBackDropState(false)
      toast.error("An error occurred...!")

      console.log("Error creating data unit:",error);
    }
  };



  // MetaMask connection component
  const MetaMaskConnect = () => (
    <div style={{ display: "flex", justifyContent: "center", width: "100%", backgroundColor: "#F3F4F8", minHeight: "60vh" }}>
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "50%"
      }}>
        <Box sx={{ 
          textAlign: 'center', 
          p: 4, 
          backgroundColor: 'white', 
          borderRadius: 2, 
          boxShadow: 2,
          maxWidth: 400
        }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#1976d2', mb: 3 }}>
            Connect MetaMask
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 3, color: '#666' }}>
            To tokenize funds, you need to connect your MetaMask wallet first.
          </Typography>
          
          {!window.ethereum ? (
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" sx={{ color: '#f44336', mb: 2 }}>
                MetaMask is not installed. Please install MetaMask extension first.
              </Typography>
              <Button 
                variant="contained" 
                color="primary" 
                href="https://metamask.io/download/" 
                target="_blank"
                sx={{ mt: 2 }}
              >
                Install MetaMask
              </Button>
            </Box>
          ) : (
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              onClick={initWeb3}
              sx={{ 
                px: 4, 
                py: 1.5, 
                fontSize: '1.1rem',
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0'
                }
              }}
            >
              Connect MetaMask
            </Button>
          )}
          
          <Typography variant="body2" sx={{ mt: 3, color: '#999', fontSize: '0.9rem' }}>
            Make sure you have MetaMask installed and unlocked
          </Typography>
        </Box>
      </div>
    </div>
  );

  return (
    <>
      {!isconnected ? (
        <MetaMaskConnect />
      ) : (
        <div style={{ display:"flex",justifyContent:"center", width: "100%", backgroundColor: "#F3F4F8" }}>
          <components.Loader.Back_Drop state={BackDropState}/>

          <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              width:"50%"
            }}>
                  <span className='Loginheading'>
                Tokenize Fund
          </span>
          <div  className='LoginScreen'>
         {/* ⚡ Unit Type: Always visible, default "None" */}
        {!isFundProvider && (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly" }}>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
            <span style={{ width: "90%", fontFamily: 'Manrope, sans-serif' }}>Unit Type</span>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
            <FormControl style={{ width: "90%" }}>
              <InputLabel id="demo-simple-select-label">Select Market</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={dataunittype} // ✅ controlled
                label="Select Market"
                error={Validation.market}
                onChange={(event) => setdataunittype(event.target.value)}
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="FX">FX</MenuItem>
                <MenuItem value="Crypto">Crypto</MenuItem>
                <MenuItem value="Commodities">Commodities</MenuItem>
                <MenuItem value="Equities">Equities</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
              <FormHelperText error>{Validation.market}</FormHelperText>
            </FormControl>
          </div>
        </div>
        )}

        {/* Only show the Instrument section if Market is not "None" */}
        {/* {dataunittype !== "None" && ( */}
        {instrument !== "Other" && (
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly" }}>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
              <span style={{ width: "90%", fontFamily: 'Manrope, sans-serif' }}>Instrument Type</span>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
              <FormControl style={{ width: "90%" }} >
                {isFundProvider ? (
                  // Auto-populated, read-only for Fund Provider
                  <TextField
                    value={"Fund"}
                    disabled
                    label="Instrument"
                  />
                ) : (
                  <>
                    <InputLabel id="demo-simple-select-label">Select Instrument</InputLabel>
                    <Select
                      value={instrument}
                      onChange={(e) => { setinstrument(e.target.value) }}
                      error={Validation.instrument}
                      label="Select Instrument"
                      variant="outlined"
                    >
                      <MenuItem value="TDU">TDU</MenuItem>
                      <MenuItem value="HFDU">HFDU</MenuItem>
                      <MenuItem value="SDU">SDU</MenuItem>
                      <MenuItem value="Fund">Fund</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </>
                )}
                <FormHelperText error>{Validation.instrument ? Validation.instrument : ""}</FormHelperText>
              </FormControl>
            </div>
          </div>
        )}


        {/* Hide the Instrument field if "Other" is selected */}
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly" }}>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
              <span style={{ width: "90%", fontFamily: 'Manrope, sans-serif' }}>Fund Unit Name</span>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
              <TextField helperText={Validation.UnitName} error={Validation.UnitName} onChange={(e) => setdata(e.target.value)} value={data} style={{ width: "90%" }} id="outlined-basic" label=" e.g 6M-FWD-2023-09-26" variant="outlined" />
            </div>
          </div>

        {/* Pricing Type selector */}
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly" }}>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
            <span style={{ width: "90%", fontFamily: 'Manrope, sans-serif' }}>Pricing Type</span>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
            <FormControl style={{ width: "90%" }}>
              <InputLabel id="pricing-type-label">Select Pricing Type</InputLabel>
              <Select
                labelId="pricing-type-label"
                id="pricing-type"
                value={pricingType}
                label="Select Pricing Type"
                onChange={(e) => setPricingType(e.target.value)}
              >
                <MenuItem value="fixed">Fixed</MenuItem>
                <MenuItem value="levels">Pricing by Levels</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        {/* Fixed pricing inputs */}
        {pricingType === 'fixed' && (
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly" }}>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
              <span style={{ width: "90%", fontFamily: 'Manrope, sans-serif' }}>Ticket Value</span>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", width: "94%", alignSelf: "center" }}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 10 }}>
                <span style={{ fontFamily: 'Manrope, sans-serif', width: "40px" }}>USD</span>
                <TextField helperText={Validation.priceUSD} error={Validation.priceUSD} onChange={(event) => {
                  const usdValue = event.target.value;
                  console.log('USD input changed to:', usdValue);
                  console.log('Current ETH price:', ethPrice);
                  setTDUPrice(usdValue);
                  // Calculate ETH from USD using current market rate
                  const ethValue = usdToEth(usdValue);
                  console.log('Calculated ETH value:', ethValue);
                  setPrice(ethValue);
                }} value={TDUPrice} style={{ width: "90%" }} type='number' id="outlined-basic" label="Type Unit Price in USD here" variant="outlined" />
              </div>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 10 }}>
                <span style={{ fontFamily: 'Manrope, sans-serif' }}>ETH</span>
                <TextField type='number' helperText={Validation.priceTDU} error={Validation.priceTDU} value={price ? Number(price).toFixed(6) : '0.000000'} style={{ width: "90%" }} id="outlined-basic" label="ETH Price will be calculated here automatically" variant="outlined" disabled />
              </div>
              {/* Debug info */}
              <div style={{ marginTop: 10, padding: 10, backgroundColor: '#f0f0f0', borderRadius: 4 }}>
                <div>Debug Info:</div>
                <div>ETH Price: {ethPrice}</div>
                <div>USD Value: {TDUPrice}</div>
                <div>Calculated ETH: {price ? Number(price).toFixed(6) : '0.000000'}</div>
                <div>Calculation: {TDUPrice} / {ethPrice} = {ethPrice ? (TDUPrice / ethPrice).toFixed(6) : 'N/A'}</div>
              </div>
            </div>
          </div>
        )}

        {/* Levels pricing inputs */}
        {pricingType === 'levels' && (
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly" }}>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
              <span style={{ width: "90%", fontFamily: 'Manrope, sans-serif' }}>Pricing Levels</span>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", width: "94%", alignSelf: "center" }}>
              {/* Yes/No radio for multiple levels as per design */}
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 10 }}>
                <div style={{ width: '90%' }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Does your Fund have more than one Investing Level?</Typography>
                  <RadioGroup row value={hasMultipleLevels ? 'yes' : 'no'} onChange={(e) => setHasMultipleLevels(e.target.value === 'yes')}>
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  </RadioGroup>
                </div>
              </div>
              {pricingLevels.map((lvl, idx) => (
                <div key={idx} style={{ 
                  border: '1px solid #e0e0e0', 
                  borderRadius: 8, 
                  padding: 20, 
                  marginTop: 16,
                  backgroundColor: '#f5f5f5'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '18px' }}>Level {idx + 1}</Typography>
                    {pricingLevels.length > 1 && (
                      <Button color="error" variant="outlined" size="small" onClick={() => removePricingLevel(idx)}>Remove</Button>
                    )}
                  </div>
                  
                  {/* Two Column Layout - Left and Right */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                    {/* Left Column */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                      <TextField 
                        value={lvl.levelName} 
                        onChange={(e) => updatePricingLevel(idx, 'levelName', e.target.value)} 
                        label="Level Name (e.g., 1)" 
                        variant="outlined" 
                        fullWidth 
                      />
                      <TextField 
                        type='number' 
                        inputProps={{ min: 0 }} 
                        value={lvl.ticketETH ? Number(lvl.ticketETH).toFixed(6) : '0.000000'} 
                        label="Ticket size in ETH (calculated from USD)" 
                        variant="outlined" 
                        fullWidth
                        disabled 
                      />
                    </div>
                    
                    {/* Right Column */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                      {/* Minimum on top */}
                      <TextField 
                        type='number' 
                        inputProps={{ min: 0 }} 
                        value={lvl.ticketUSD || ''} 
                        onChange={(e) => updatePricingLevel(idx, 'ticketUSD', e.target.value)} 
                        label="Minimum Level Contribution (Ticket) USD" 
                        variant="outlined" 
                        fullWidth 
                      />
                      {/* Maximum on bottom */}
                      <TextField 
                        type='number' 
                        inputProps={{ min: 0 }} 
                        value={lvl.maxAmountUSD || ''} 
                        onChange={(e) => updatePricingLevel(idx, 'maxAmountUSD', e.target.value)} 
                        label="Maximum Amount for Level (USD)" 
                        variant="outlined" 
                        fullWidth 
                      />
                    </div>
                  </div>
                  
                  {/* Coin and Yield Details Section */}
                  <div style={{ 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 8, 
                    padding: 16, 
                    marginTop: 24, 
                    backgroundColor: '#ffffff'
                  }}>
                    {/* Row 1: Three fields - Coin Price, Annual Yield %, and Coin */}
                    <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                      <TextField 
                        type='number' 
                        inputProps={{ min: 0, step: 0.01 }} 
                        value={lvl.coinPriceUSD || ''} 
                        onChange={(e) => {
                          const val = e.target.value.replace(/^0+(?=\d)/, '');
                          updatePricingLevel(idx, 'coinPriceUSD', val ? Number(val) : 0);
                        }}
                        label="Coin Price in USD" 
                        variant="outlined" 
                        style={{ flex: 1 }}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">$</InputAdornment>
                        }}
                      />
                      <TextField 
                        type='number' 
                        inputProps={{ min: 0, step: 0.1 }} 
                        value={lvl.annualYieldPercent || ''} 
                        onChange={(e) => {
                          const val = e.target.value.replace(/^0+(?=\d)/, '');
                          updatePricingLevel(idx, 'annualYieldPercent', val);
                        }}
                        label="Annual Yield %" 
                        variant="outlined" 
                        style={{ flex: 1 }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>
                        }}
                      />
                      <FormControl variant="outlined" style={{ flex: 1 }}>
                        <InputLabel id={`coin-select-label-${idx}`}>Coin</InputLabel>
                        <Select
                          labelId={`coin-select-label-${idx}`}
                          value={selectedCoin}
                          onChange={(e) => setSelectedCoin(e.target.value)}
                          label="Coin"
                        >
                          <MenuItem value="TDUX">TDUX</MenuItem>
                          {/* Future coins can be added here */}
                        </Select>
                      </FormControl>
                    </div>
                    
                    {/* Row 2: Two fields - INVESTMENT per Ticket and Annual Yield in Coin */}
                    <div style={{ display: 'flex', gap: 16 }}>
                      <TextField
                        type='text'
                        value={`${calculateInvestmentPerTicket(lvl.coinPriceUSD, lvl.ticketUSD)} ${selectedCoin}`}
                        label="INVESTMENT per Ticket"
                        variant="outlined"
                        style={{ flex: 1 }}
                        disabled
                      />
                      <TextField
                        type='text'
                        value={`${calculateAnnualYieldInCoin(calculateInvestmentPerTicket(lvl.coinPriceUSD, lvl.ticketUSD), lvl.annualYieldPercent) || '0'} ${selectedCoin}`}
                        label="Annual Yield in Coin"
                        variant="outlined"
                        style={{ flex: 1 }}
                        disabled
                      />
                    </div>
                  </div>
                  
                  {/* Final Fund Unit Name */}
                  <div style={{ marginTop: 20 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
                      Final Fund Unit Name
                    </Typography>
                    <TextField 
                      disabled 
                      value={`${data || 'Langley'} - Level ${lvl.levelName || ''} - Max USD ${lvl.maxAmountUSD || 0}`} 
                      fullWidth 
                      variant="outlined"
                    />
                  </div>
                </div>
              ))}
              {hasMultipleLevels && (
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                  <Button variant="contained" onClick={addPricingLevel}>+ Additional Level</Button>
                </div>
              )}
              <FormHelperText error>{Validation.pricingLevels ? Validation.pricingLevels : ""}</FormHelperText>
            </div>
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly" }}>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
            <span style={{ width: "90%", fontFamily: 'Manrope, sans-serif' }}>Select MetaMask Account Number</span>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
            <FormControl style={{ width: "90%" }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={accountNumber}
                error={Validation.metaAccountNumber}
                onChange={(event) => { setaccountNumber(event.target.value) }}
              >
                {
                  WalletAddresses?.map((account) => (
                    <MenuItem key={account} value={account}>
                      {account}
                    </MenuItem>
                  ))
                }

              </Select>
              <FormHelperText error>{Validation.metaAccountNumber ? Validation.metaAccountNumber : ""}</FormHelperText>
            </FormControl>
          </div>
        </div>
        <div style={{ display: "flex", width: "90%", alignSelf: "center", justifyContent: "flex-end", paddingBottom: 20, paddingTop: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-evenly" }}>
            {/* <Button variant="outlined">Cancel</Button> */}
            <Button onClick={handleSave} variant="contained">Submit</Button>
          </div>
        </div>

          </div>
        </div>
        </div>
      )}
    </>
  )
}

export default TokenizeData